import { WriteRequest } from "~/backendApis/foundation/WriteRequest"

interface Params {
  chatGroupId: string
  textMessage: string
}

export class SendMessageWriteRequest extends WriteRequest<void> {
  private readonly params: Params

  constructor(params: Params) {
    super()
    this.params = params
  }

  public post(): Promise<void> {
    const { textMessage } = this.params
    return this.apiClient.post(this.makeEndpoint(), { textMessage })
  }

  private makeEndpoint(): string {
    return `/matching/user/chat_group/${this.params.chatGroupId}/message/create`
  }
}
